import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import Swal from 'sweetalert2';
import api3000 from '../../services/api3000';

const fadeScaleIn = keyframes`
  0% { opacity: 0; transform: scale(0.7); }
  100% { opacity: 1; transform: scale(1); }
`;

const Overlay = styled.div`
  position: fixed;
  top: 0; left: 0;
  width: 100%; height: 100%;
  background: rgba(0,0,0,0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const Modal = styled.div`
  background: #fff;
  border-radius: 12px;
  padding: 25px 30px;
  width: 400px;
  max-width: 90%;
  animation: ${fadeScaleIn} 0.3s ease-out;
  box-shadow: 0 8px 20px rgba(0,0,0,0.25);
`;

const Title = styled.h2`
  margin-bottom: 20px;
  text-align: center;
`;

const Input = styled.input`
  width: 80%;
  display: block;
  margin: 0 auto 15px auto;
  padding: 10px;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  font-size: 14px;

  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;

const Select = styled.select`
  width: 84%;
  display: block;
  margin: 0 auto 15px auto;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #dcdcdc;
  font-size: 14px;

  &:focus {
    border-color: #3085d6;
    outline: none;
    box-shadow: 0 0 0 2px rgba(51, 153, 255, 0.2);
  }
`;

const ButtonRow = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin-top: 10px;
`;

const Button = styled.button`
  padding: 10px 20px;
  border-radius: 6px;
  border: none;
  cursor: pointer;
  font-weight: bold;
  transition: all 0.2s ease;
  background: ${(props) => (props.primary ? '#3085d6' : '#dcdcdc')};
  color: ${(props) => (props.primary ? '#fff' : '#000')};

  &:hover { opacity: 0.9; transform: translateY(-1px); }
  &:active { transform: translateY(0); opacity: 0.8; }
`;

const UserFormEdit = ({ user, onClose, onUpdated }) => {
  const [form, setForm] = useState({
    nome: user.nome || '',
    email: user.email || '',
    nivel_acesso: user.nivel_acesso || 'operador',
  });

  const handleChange = e => {
    const { name, value } = e.target;

    const limits = {
      nome: 100,
      email: 100
    };

    if (limits[name] && value.length > limits[name]) return;

    setForm({ ...form, [name]: value });
  };

  const handleSave = async () => {
    const { nome, email, nivel_acesso } = form;

    if (!nome || !email) {
      Swal.fire({ icon: 'error', title: 'Erro', text: 'Nome e email são obrigatórios.' });
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire({ icon: 'error', title: 'Erro', text: 'Por favor, informe um e-mail válido.' });
      return;
    }

    try {
      const token = localStorage.getItem('token');
      await api3000.put(`/api/users/${user.id}`, { nome, email, nivel_acesso }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      Swal.fire({ icon: 'success', title: 'Sucesso!', text: 'Usuário atualizado com sucesso.', showConfirmButton: false, timer: 1800 });
      onUpdated();
      onClose();
    } catch (err) {
      Swal.fire({ icon: 'error', title: 'Erro', text: err.response?.data?.message || err.message });
    }
  };

  useEffect(() => {
    document.getElementById('nome-input')?.focus();
  }, []);

  return (
    <Overlay>
      <Modal>
        <Title>Editar Usuário</Title>
        <Input
          id="nome-input"
          name="nome"
          placeholder="Nome"
          value={form.nome}
          onChange={handleChange}
          maxLength={100}
        />

        <Input
          name="email"
          type="email"
          placeholder="Email"
          value={form.email}
          onChange={handleChange}
          maxLength={100}
        />
        <Select name="nivel_acesso" value={form.nivel_acesso} onChange={handleChange}>
          <option value="operador">Operador</option>
          <option value="admin">Admin</option>
        </Select>
        <ButtonRow>
          <Button type="button" onClick={onClose}>Cancelar</Button>
          <Button type="button" primary onClick={handleSave}>Salvar</Button>
        </ButtonRow>
      </Modal>
    </Overlay>
  );
};

export default UserFormEdit;
